import config from './config.json';

export const apiHost = config.apiHost